import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getLessonRequest } from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import Viewer from '../../../components/builder/viewer'

export const StudentRunLesson = () => {
  const [loading, setLoading] = useState(false)
  const [practice, setPractice] = useState(null)

  const { id } = useParams()

  useEffect(() => {
    const fetchAsync = async () => {
      setLoading(true)
      const response = await getLessonRequest(id)
      setPractice(response.data?.item)
      setLoading(false)
    }
    fetchAsync()
  }, [])

  const handleFinishClick = () => {
    window.history.back()
  }

  if (loading || !practice) {
    return null
  }

  return (
    <div className="practice-viewer">
      <Viewer
        mode="authorize"
        practice={practice}
        onFinishClick={handleFinishClick}
      />
    </div>
  )
}
